import { Component, Inject, Optional } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  templateUrl: './confirmation.dialog.html',
  styleUrls: ['./confirmation.dialog.scss'],
})
export class ConfirmationDialog {
  constructor(
    public readonly dialogRef: MatDialogRef<ConfirmationDialog>,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public readonly config: {
      title: string;
      content: string;
    }
  ) {}

  public static width: string = '320px';
}

export default ConfirmationDialog;
